import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Large = props => <p className="c-vi-large-text">{props.children}</p>;

Large.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Large;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Large.jsx